"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var index_1 = __importStar(require("../Button/index"));
var Icon_1 = __importStar(require("../Icon"));
var ContentRow = /** @class */ (function (_super) {
    __extends(ContentRow, _super);
    function ContentRow(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleOpen = function (e) {
            _this.scrollToView(e.currentTarget);
            _this.setState(function (_a) {
                var isOpen = _a.isOpen;
                return ({ isOpen: !isOpen });
            });
        };
        _this.scrollToView = function (target) {
            if (!_this.state.isOpen) {
                requestAnimationFrame(function () {
                    target.scrollIntoView({ behavior: "smooth", block: "center" });
                });
            }
        };
        _this.state = {
            isOpen: props.item.isOpen || false,
            prevItem: props.item,
        };
        return _this;
    }
    ContentRow.getDerivedStateFromProps = function (props, state) {
        if (props.item !== state.prevItem) {
            return {
                prevItem: props.item,
                isOpen: props.item.isOpen || false,
            };
        }
        return null;
    };
    ContentRow.prototype.render = function () {
        var _this = this;
        var isOpen = this.state.isOpen;
        var _a = this.props, children = _a.children, columns = _a.columns, value = _a.value, item = _a.item, selectableRows = _a.selectableRows, sortColumn = _a.sortColumn, onClick = _a.onClick;
        var openButton = (react_1.default.createElement(index_1.default, { variant: isOpen ? index_1.ButtonVariant.Normal : index_1.ButtonVariant.Active },
            react_1.default.createElement(Icon_1.default, { icon: isOpen ? Icon_1.IconType.ArrowTop : Icon_1.IconType.ArrowBottom })));
        var columnsData = columns.map(function (column) {
            var columnValue = column.id !== "action" ? value(item, column.id) : "";
            var columnData = column.openerButton ? openButton : columnValue;
            var className = classnames_1.default({
                sorted: sortColumn === column.id,
                children_opener: column.childrenOpener,
            }, column.className || column.id, column.align || "");
            return (react_1.default.createElement("td", { key: "parent_column-" + column.id, className: className, onClick: column.childrenOpener ? _this.toggleOpen : undefined }, columnData));
        });
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("tr", { className: "content_row", onClick: onClick },
                selectableRows && react_1.default.createElement("td", null),
                columnsData),
            isOpen && (react_1.default.createElement("tr", { className: "subcontent_row" },
                react_1.default.createElement("td", { colSpan: columns.length }, children)))));
    };
    return ContentRow;
}(react_1.default.Component));
exports.default = ContentRow;
//# sourceMappingURL=ContentRow.js.map